import React from 'react';
import PropTypes from 'prop-types';
import { compose, pure, defaultProps } from 'recompose';
import styled from 'styled-components';
import { prop } from 'styled-tools';

import ApplicationDocumentsTree from 'components/blocks/ApplicationDocumentsTree';
import reduxConnect from 'components/blocks/ApplicationDocumentsTree/hocs/reduxConnect';

const propTypes = {
  isEmpty: PropTypes.bool.isRequired,
};

function DownloadDocuments(props) {
  const { isEmpty } = props;

  if (isEmpty) return null;

  return (
    <Container>
      <ApplicationDocumentsTree {...props} />
    </Container>
  );
}

const Container = styled.div`
  padding: 2.1875rem 3rem 2.1875rem 1.5625rem;

  @media (max-width: ${prop('theme.breakpoints.1')}) {
    padding: 2.1875rem 0;
  }
`;

DownloadDocuments.propTypes = propTypes;

const enhance = compose(
  defaultProps({
    withRequestedDocuments: false,
    withContactProfileDocuments: false,
    withEntityDocuments: false,
    withLoanDocuments: false,
    withPropertyDocuments: false,
    withDownLoadDocuments: true,
    withAnotherDocuments: false,
  }),
  reduxConnect,
  pure,
);

export default enhance(DownloadDocuments);
